/* Imported in email component but unused */
export class EmailCampaign {
  id: string;
  title: string;
  emails_sent: number;
  unsubscribed: number;
}
